module.exports = __webpack_public_path__ + "media/images/sites/health/favicon-144x144-699077f2b8863581401e4253e33a1c17.png";